import $ from 'domtastic'
import mapboxgl from 'mapbox-gl'

class SearchDetailMap {
  constructor() {
    this.initializeMap()
  }

  initializeMap() {
    mapboxgl.accessToken = rentler.listings.mapboxToken
    var map = new mapboxgl.Map({
      container: 'search-detail-map',
      style: 'mapbox://styles/rentler/ck2z9y0ey0ge61cs3v1ur3yvo',
      center: document
        .getElementById('search-detail-map')
        .attributes['data-pin-coordinates'].value.split(','),
      zoom: 12,
    })

    // disable map zoom when using scroll
    map.scrollZoom.disable()

    // add zoom controls
    map.addControl(new mapboxgl.NavigationControl())

    var popup = new mapboxgl.Popup({ closeOnClick: false })
      .setLngLat(
        document
          .getElementById('search-detail-map')
          .attributes['data-pin-coordinates'].value.split(',')
      )
      .setHTML(
        `
        <div class="get-directions-popup">
          <div class="address">
            ${
              document.getElementById('search-detail-map').attributes[
                'data-address-html'
              ].value
            }
          </div>
          <div href="https://www.google.com/maps/dir/?api=1&destination=${
            document.getElementById('search-detail-map').attributes[
              'data-address'
            ].value
          }" class="get-directions-button">
            <i class="icon-directions"></i>
            <span>
              Directions
            </span>
          </div>

        </div>
      `
      )
      .addTo(map)

    // Directions
    $('.get-directions-button').on('click', function (e) {
      const href = $(this).attr('href')
      window.open(href)
    })

    // create a DOM element for the marker
    var markerEl = document.createElement('div')
    markerEl.className = 'marker-point'

    new mapboxgl.Marker({
      element: markerEl,
    })
      .setLngLat(
        document
          .getElementById('search-detail-map')
          .attributes['data-pin-coordinates'].value.split(',')
      )
      .addTo(map)
  }
}

export default SearchDetailMap
